<div class="p-formgrid" style="overflow-x: hidden;">
    <p-toast [preventDuplicates]="true" [preventOpenDuplicates]="true"/>
    <app-login-header></app-login-header>

    <div class="carousel-login-wrapper">
        <p-carousel
            [value]="images"
            [numVisible]="1"
            [numScroll]="1"
            [circular]="true"
            [autoplayInterval]="4000"
            [showNavigators]="false"

            [showIndicators]="false"
            class="custom-carousel">
            <ng-template pTemplate="item" let-img>
                <img [src]="img" class="gallery-image" alt="Imagen"/>
            </ng-template>
        </p-carousel>



        <div class="login-card flex justify-content-center align-items-start sm:align-items-center w-full min-h-screen px-4 pt-4 sm:pt-0">
            <div class="flex flex-row-reverse justify-content-center align-items-center w-full">
                <div class="surface-card py-7 px-5 sm:px-7 shadow-2 flex flex-column w-11 sm:w-30rem"
                     style="border-radius:14px;">
                    <div class="row overflow-hidden">
                        <div class="col-12" style="text-align: center;">
                            <p-image [src]="logoCNR" alt="Image" width="150" class=""></p-image>
                        </div>
                    </div>
                    <br>
                    <span class="p-input-icon-left mb-4 data-private">
                    <i class="pi pi-user"></i>
                    <input type="text" required [ngClass]="{'ng-invalid ng-dirty' : camposCompletos && !usuario}"
                           pInputText placeholder="Correo eléctronico o usuario" class="w-full text-2xl sm:text-base sm:h-4rem" [(ngModel)]="usuario">
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="camposCompletos && !usuario"><b>Favor
                            el correo o nombre de usuario</b></small>
                </span>
                    <span class="mb-4 data-private">
                       <p-password [(ngModel)]="password"
                                   [toggleMask]="true"
                                   [feedback]="false"
                                   data-private
                                   required
                                   inputStyleClass="w-full text-2xl sm:text-base p-3 sm:h-4rem"
                                   styleClass="w-full"
                                   [ngClass]="{'ng-invalid ng-dirty' : camposCompletos && !password}"
                                   placeholder="Contraseña"/>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="camposCompletos && !password"><b>Favor
                            validar la contraseña</b></small>
                </span>
                    <p-button
                        id="btnIniciarSesion"
                        icon="pi pi-check"
                        label="Iniciar sesión"
                        [loading]="loading"
                        [disabled]="deshabilitarLogin || !usuario || !password"
                        styleClass="p-button-rounded p-button-info w-full text-xl"
                        (click)="login()"/>

                    <br/>

                    <p-button
                        id="btnIniciarSesion"
                        label="Entrar con Identidad Digital"
                        *ngIf="mostrarLoginSV"
                        [disabled]="usuario && password"
                        styleClass="p-button-rounded p-button-info w-full text-xl"
                        (click)="confirmarLoginSV()">
                        <ng-template pTemplate="icon">
                            <img src="/assets/demo/images/logos/logo_ID.png" alt="ID"
                                 style="width: 2.5rem; height: 1.1rem;"/>
                        </ng-template>
                    </p-button>

                    <p-confirmDialog>

                    </p-confirmDialog>


                    <div class="row">
                        <div class="col">
                            <a [routerLink]="['/auth/register']" routerLinkActive="router-link-active"
                               [queryParams]="{sessionId: sessionId}"
                               class="text-center">
                                <p style="font-size:1.2rem">Registrate</p>
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <a [routerLink]="['/auth/forgotpassword']" routerLinkActive="router-link-active"
                               [queryParams]="{sessionId: sessionId}"
                               class="text-center">
                                <p style="font-size:1.2rem">Recuperar contraseña</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p-sidebar [(visible)]="registerSent" closeOnEscape="false" position="top">
            <div class="flex justify-content-center flex-wrap">
                <h3 class="text-green-500">¡Registro exitoso! Recibirás un correo electrónico para activar tu
                    cuenta.</h3>
            </div>
        </p-sidebar>
    </div>
    <app-login-footer></app-login-footer>
</div>
